import { useAllocation } from '../useAllocation';
import { twentyVsThirtyExp, variantExp } from '../../experiments/frontDoorOffer';
export { twentyVsThirtyExp, variantExp } from '../../experiments/frontDoorOffer';
export const useFrontDoorOffer = (skip = false) => {
  const {
    data: allocationData,
    loading
  } = useAllocation(skip ? [] : [twentyVsThirtyExp, variantExp]);
  const isThirtyDollarTreatment = allocationData?.visitor?.configParams?.find(p => p.name === twentyVsThirtyExp.name)?.value === 'thirty';
  const slimBannerVariant = allocationData?.visitor?.configParams?.find(p => p.name === variantExp.name)?.value || variantExp.fallbackValue;
  return {
    isThirtyDollarTreatment,
    offerAmount: isThirtyDollarTreatment ? 30 : 20,
    slimBannerVariant,
    loading
  };
};